import React, { useState } from "react";
import CasinoCard from "./CasinoCard";

const GamesProviderSection = ({
  data,
  providers,
  isMobile = false,
  setShowAuthModals,
}) => {
  const slicedIndex = isMobile ? 6 : 10;
  const [activeProvider, setActiveProvider] = useState(providers[0]);
  const handleProviderChange = (provider) => {
    setActiveProvider(provider);
  };

  return (
    <div className="ProviderSection">
      <ul className="d-flex ProvidersTabs">
        {providers.map((provider, idx) => (
          <li
            key={idx}
            style={activeProvider.key === provider.key ? { color: "#fff" } : {}}
            onClick={() => handleProviderChange(provider)}
            className={activeProvider.key === provider.key && "active"}
          >
            {provider.name}
          </li>
        ))}
      </ul>
      <ul className="d-flex ProvidersGamesContent position-relative">
        {data
          ?.filter(
            (f) =>
              f?.provider && f?.provider?.toLowerCase() === activeProvider?.key
          )
          ?.slice(0, slicedIndex)
          ?.map((game, idx) => {
            return (
              <CasinoCard
                customImageText={`More ${activeProvider?.name} Games`}
                isLastElement={
                  data
                    ?.filter(
                      (f) =>
                        f?.provider &&
                        f?.provider?.toLowerCase() === activeProvider?.key
                    )
                    ?.slice(0, slicedIndex).length ===
                  idx + 1
                }
                data={game}
                index={idx}
                lastElementUrl={activeProvider?.redirectLastItem}
                setShowAuthModals={setShowAuthModals}
              />
            );
          })}
        {/* <h2>View More Games</h2> */}
      </ul>
    </div>
  );
};
export default GamesProviderSection;
